import { debugAtom } from "@folio-2026/experience/debug"
import { useAtomValue } from "jotai"

export default function useDebug() {
  return useAtomValue(debugAtom)
}
